import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ErrorGlyph = /*#__PURE__*/createElement("g", {
  id: "error"
}, /*#__PURE__*/createElement("path", {
  d: "M42,18c13.2,0,24,10.8,24,24S55.2,66,42,66S18,55.2,18,42S28.8,18,42,18 M42,15c-14.9,0-27,12.1-27,27 s12.1,27,27,27s27-12.1,27-27S56.9,15,42,15L42,15z"
}), /*#__PURE__*/createElement("path", {
  d: "M44.3,42l8.2-8.2c0.3-0.3,0.5-0.7,0.5-1.2c0-0.4-0.2-0.9-0.5-1.2c-0.6-0.6-1.7-0.6-2.3,0L42,39.7l-8.2-8.2 c-0.6-0.6-1.7-0.6-2.3,0c-0.6,0.6-0.6,1.7,0,2.3l8.2,8.2l-8.2,8.2c-0.6,0.6-0.6,1.7,0,2.3c0.6,0.6,1.7,0.6,2.3,0l8.2-8.2l8.2,8.2 c0.3,0.3,0.7,0.5,1.2,0.5c0.4,0,0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.2c0-0.4-0.2-0.9-0.5-1.2L44.3,42z"
}));
const Error = createSvg({
  name: 'error',
  path: ErrorGlyph
});

export default Error;
export { ErrorGlyph };
